import {
  Alert,
  Col,
  FormGroup,
  Row,
} from 'reactstrap';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import MoneyInput from '../../../../components/MoneyInput';
import { CreatePropertySalesInfoForm } from '../../models/propertyModel';
import { moneyFields } from './salesFields';

interface Props {
  control: Control<CreatePropertySalesInfoForm>;
  errors: FieldErrors<CreatePropertySalesInfoForm>;
  symbol?: string;
  // Sin precio de reserva guardado el plan de pagos no se muestra en la web.
  missingReservePrice: boolean;
}

const SalesFinancialFields = ({
  control,
  errors,
  symbol,
  missingReservePrice,
}: Props) => (
  <>
    <small className="d-block mb-3" style={{ color: '#525f7f' }}>
      Llena el precio de reserva y el de prima: con ellos se arma el plan de pagos que se muestra en la página web.
    </small>
    {missingReservePrice && (
      <Alert color="warning" className="py-2">
        Esta propiedad todavía no tiene precio de reserva guardado, así que el
        plan de pagos no se verá en la página web hasta que lo llenes y guardes.
      </Alert>
    )}
    <Row>
      {moneyFields.map(({ name, label }) => (
        <Col lg="3" md="6" key={name}>
          <FormGroup className="mb-3">
            <label className="form-control-label" htmlFor={name}>
              {label}
            </label>
            <Controller
              name={name}
              control={control}
              render={({ field }) => (
                <MoneyInput
                  id={name}
                  symbol={symbol}
                  value={field.value}
                  onChange={field.onChange}
                  invalid={!!errors[name]?.message}
                />
              )}
            />
            {errors[name]?.message && (
              <h5 className="text-danger mt-1 mb-0">{errors[name]?.message}</h5>
            )}
          </FormGroup>
        </Col>
      ))}
    </Row>
  </>
);

export default SalesFinancialFields;
